import ActionLink from 'components/action-link/action-link.component';
import styled from 'styled-components';

export const StyledActionLink = styled(ActionLink)`
  display: inline-block;
`;
